"use client"

import { useClientTranslations } from "@/hooks/useClientTranslations"
import type {
    WarehouseFlowRow,
    WarehouseFlowSite,
    WarehouseFlowView,
} from "./warehouseFlow.utils"

export function useWarehouseFlowNames(shape: WarehouseFlowView["shape"]) {
    const t = useClientTranslations("desktop.warehouseFlow")

    const siteName = (site: WarehouseFlowSite) =>
        site.kind === "site" && site.place
            ? site.place
            : t(`site.${site.kind === "none" ? "none" : "other"}.${shape}`, {
                  count: site.placeCount,
              })

    const rowName = (row: WarehouseFlowRow) => {
        if (row.kind === "party") {
            return row.party.name ?? row.party.place ?? t("noName")
        }
        return row.counterpartyCount > 0
            ? t(`more.${shape}`, { count: row.counterpartyCount })
            : t("more.unnamed")
    }

    return { siteName, rowName }
}
